import type { HabilitationStatus } from './api/client';

export const STATUS_LABELS: Record<HabilitationStatus, string> = {
  demandee: 'Demandée',
  active: 'Active',
  suspendue: 'Suspendue',
  retiree: 'Retirée',
  refusee: 'Refusée',
  expiree: 'Expirée',
  a_venir: 'À venir',
};

export const STATUS_TONE: Record<HabilitationStatus, 'info' | 'ok' | 'warn' | 'muted' | 'danger'> = {
  demandee: 'info',
  active: 'ok',
  suspendue: 'warn',
  retiree: 'muted',
  refusee: 'danger',
  expiree: 'muted',
  a_venir: 'info',
};

export const KIND_LABELS: Record<string, string> = {
  agent: 'Agent',
  usager: 'Usager',
  organisme: 'Organisme',
  technique: 'Technique',
};

export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('fr-FR', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'Africa/Libreville',
  }).format(new Date(iso));
}
